import { FC } from 'react';
import { FormikProps, isValidCpfCnpj, useFormikContext } from '~/modules';
import { maskCpfOrCnpj } from '~/utils';
import { ButtonSearch, ContentBox, Input, Title, Wrapper } from './styles';

type Props = {
  isSubmitting: boolean;
};

const AuditSearch: FC<Props> = ({ isSubmitting }) => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    submitForm,
  }: FormikProps<SearchClient> = useFormikContext();

  return (
    <Wrapper titlePage="Buscar">
      <ContentBox>
        <Title>Log de ações</Title>
        <Input
          id="document"
          name="document"
          placeholder="Digite o CPF ou CNPJ completo"
          type="filter"
          value={values.document}
          error={touched?.document && errors?.document}
          onChange={({ target }) => {
            setFieldValue('document', maskCpfOrCnpj(target.value));
          }}
        />

        <ButtonSearch
          id="btn_search_client"
          onLoading={isSubmitting}
          onKeyEnter
          onPress={submitForm}
          disabled={!isValidCpfCnpj(values.document)}
        >
          Buscar
        </ButtonSearch>
      </ContentBox>
    </Wrapper>
  );
};

export default AuditSearch;
